import React from "react"

const ImageClipped = ({ opacity, maskStyle, children }) => {
  return (
    <div className={`image-clipped ${maskStyle}`} style={{ opacity: opacity }}>
      {children}
    </div>
  )
}

export default ImageClipped
